import gql from 'graphql-tag';

export const RECOMMENDED_DATE_FUND = gql`
  query RDFQuery(
    $retirementAge: Int!
    $amountToInvest: Float!
    $birthDate: String!
    $isSummitMember: Boolean!
  ) {
    recommendedDateFund(
      birthDate: $birthDate
      retirementAge: $retirementAge
      amountToInvest: $amountToInvest
      dateFundType: RETIREMENT_DATE_FUND
      isSummitMember: $isSummitMember
    ) {
      name: shortName
      price {
        asOfDate
        price
        priceChange
      }
      netAssets
      netAssetsAsOfDate
      ticker
      trpCode
      cusip
      retirement
      targetYear
      iClass
      recordKeepingCode
      grossExpenseRatio
      morningStarRatings {
        asOfDate
        morningStarCategoryName
        morningStarOverallRating
        morningStarOverallQuantity
      }
      assetAllocationGroupedRankings {
        name
        percentTotalNetAssets
        asOfDate
      }
      twelveMonthLowPrice {
        price
      }
      twelveMonthHighPrice {
        price
      }
    }
  }
`;

export const RECOMMENDED_DATE_FUND_NO_SUMMIT = gql`
  query RDFQuery(
    $retirementAge: Int!
    $amountToInvest: Float!
    $birthDate: String!
  ) {
    recommendedDateFund(
      birthDate: $birthDate
      retirementAge: $retirementAge
      amountToInvest: $amountToInvest
      dateFundType: RETIREMENT_DATE_FUND
    ) {
      name: shortName
      price {
        asOfDate
        price
        priceChange
      }
      netAssets
      netAssetsAsOfDate
      ticker
      trpCode
      cusip
      retirement
      targetYear
      iClass
      recordKeepingCode
      grossExpenseRatio
      morningStarRatings {
        asOfDate
        morningStarCategoryName
        morningStarOverallRating
        morningStarOverallQuantity
      }
      assetAllocationGroupedRankings {
        name
        percentTotalNetAssets
        asOfDate
      }
      twelveMonthLowPrice {
        price
      }
      twelveMonthHighPrice {
        price
      }
    }
  }
`;

export const RECOMMENDED_DATE_FUND_MOCK = [
  {
    request: {
      query: RECOMMENDED_DATE_FUND
    },
    result: {
      data: {
        recommendedDateFund: {
          name: 'Retirement 2050 Fund',
          ticker: 'TRRMX',
          trpCode: 'RPL',
          morningStarRatings: {
            asOfDate: null,
            morningStarCategoryName: 'Target-Date 2050',
            morningStarOverallRating: 0,
            morningStarOverallQuantity: 0
          },
          assetAllocationGroupedRankings: [
            {
              name: 'Foreign Bonds',
              percentTotalNetAssets: 0.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            },
            {
              name: 'Options',
              percentTotalNetAssets: 0.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            },
            {
              name: 'Preferred Stock',
              percentTotalNetAssets: 0.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            },
            {
              name: 'Convertibles',
              percentTotalNetAssets: 0.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            },
            {
              name: 'Domestic Stock',
              percentTotalNetAssets: 0.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            },
            {
              name: 'Foreign Stock',
              percentTotalNetAssets: 0.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            },
            {
              name: 'Cash',
              percentTotalNetAssets: 0.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            },
            {
              name: 'Other',
              percentTotalNetAssets: 100.0,
              asOfDate: '2020-02-29T05:00:00Z',
              __typename: 'Ranking'
            }
          ],
          __typename: 'GraphQLMutualFund'
        }
      }
    }
  }
];
